
export type ComputableLayoutValuePercentTarget = 
  | 'screenSize'
  | 'windowSize'
  | 'targetSize'
  | 'currentSize'
  | 'screenWidth'
  | 'windowWidth'
  | 'targetWidth'
  | 'currentWidth'
  | 'screenHeight'
  | 'windowHeight'
  | 'targetHeight'
  | 'currentHeight';